<script lang="ts">
  import { cn } from '$lib/utils/misc';
</script>

<div class={cn('w-full animate-pulse', $$props.class)}>
  <div class="relative flex w-full items-start gap-x-2">
    <!-- Avatar skeleton -->
    <div class="bg-gray-dark-4 mt-1.5 h-6 w-6 rounded" />

    <div class="relative flex w-full flex-1 flex-col gap-4">
      <!-- Header skeleton -->
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <!-- Username skeleton -->
          <div class="bg-gray-dark-4 h-4 w-24 rounded" />
          <!-- Handle skeleton -->
          <div class="bg-gray-dark-4 h-4 w-16 rounded" />
          <!-- Time skeleton -->
          <div class="bg-gray-dark-4 h-4 w-12 rounded" />
        </div>
      </div>

      <!-- Comment body skeleton -->
      <div class="space-y-2">
        <div class="bg-gray-dark-4 h-4 w-3/4 rounded" />
        <div class="bg-gray-dark-4 h-4 w-1/2 rounded" />
      </div>

      <!-- Actions skeleton -->
      <div class="flex items-center gap-x-5">
        <div class="bg-gray-dark-4 h-4 w-16 rounded" />
        <div class="bg-gray-dark-4 h-4 w-16 rounded" />
      </div>
    </div>
  </div>
</div>
